import { APP_LOADING } from './appActionConstants';

export const setAppReady = () => ({
  type: APP_LOADING,
});
